import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { MatSelectChange } from '@angular/material/select';
import { Store, select } from '@ngrx/store';
import {
  FormGroupConfig,
  TiposDocumento
} from '@rpe/registro-personas-empresas-lib';
import { BehaviorSubject, Observable, Subscription, combineLatest } from 'rxjs';
import { State } from '../../../vista-usuario/vista-usuario.state';
import {
  DocumentoPersona,
  DocumentoPersonaFormInput,
  DocumentoPersonaSet
} from '../documentos-persona.model';
import { selectDocumentoPersonaInitialData } from '../documentos-persona.selectors';

@Component({
  selector: 'rpe-documento-persona-form',
  templateUrl: './documento-persona-form.component.html',
  styleUrls: ['./documento-persona-form.component.css']
})
export class DocumentoPersonaFormComponent implements OnInit, OnDestroy {
  @Input()
  set formInput(documentoFormInput: DocumentoPersonaFormInput) {
    this._formInput = documentoFormInput;
    //this.tiposDocumentosFiltrado = this._formInput.tipos_documento; TODO
    this._documentoInput.next(documentoFormInput.documento_persona);
  }
  get formInput(): DocumentoPersonaFormInput {
    return this._formInput;
  }

  _formInput: DocumentoPersonaFormInput;

  documentoPersonaFormGroup: FormGroup;
  tiposDocumentosFiltrado: TiposDocumento[];

  documentoPersonaSet$: Observable<DocumentoPersonaSet>;
  documentoPersonaSet: DocumentoPersonaSet;
  subscription: Subscription;
  subscriptionSetDocumento: Subscription;

  _documentoInput = new BehaviorSubject<DocumentoPersona>(null);

  constructor(private fb: FormBuilder, private store: Store<State>) {}

  private soloLectura = false;

  ngOnInit(): void {
    // Load inital data
    this.documentoPersonaSet$ = this.store.pipe(
      select(selectDocumentoPersonaInitialData)
    );
    this.subscription = combineLatest([
      this.documentoPersonaSet$,
      this._documentoInput
    ]).subscribe(([set, documento]) => {
      this.documentoPersonaSet = set;
      this.setValorDocumento(documento);
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  createGroup() {
    const config: FormGroupConfig<DocumentoPersona> = {
      id: [, []],
      pais_codigo: [, [Validators.required]],
      tipo_documento_codigo: [, [Validators.required]],
      numero: [, [Validators.required]]
    };

    this.documentoPersonaFormGroup = this.fb.group(config);
    return this.documentoPersonaFormGroup;
  }

  setValorDocumento(documento: DocumentoPersona): void {
    if (documento && this.documentoPersonaSet) {
      const paisesDocumentoSeleccionado =
        this.documentoPersonaSet.paisesDocumento.filter(
          (pd) => pd.pais_codigo === documento.pais_codigo
        );
      this.tiposDocumentosFiltrado =
        this.documentoPersonaSet.tiposDocumento.filter(
          (td) =>
            paisesDocumentoSeleccionado.findIndex(
              (pd) => pd.tipo_documento_codigo == td.codigo
            ) !== -1
        );
      this.documentoPersonaFormGroup.patchValue({
        pais_codigo: documento.pais_codigo,
        tipo_documento_codigo: documento.tipo_documento_codigo,
        numero: documento.numero
      });
    }
  }

  setSoloLectura(valor: boolean) {
    this.soloLectura = valor;
  }

  camposLectura() {
    return this.soloLectura;
  }

  limpiarCampos() {
    this.documentoPersonaFormGroup.get('id').setValue(null);
    this.documentoPersonaFormGroup.get('pais_codigo').setValue(null);
    this.documentoPersonaFormGroup.get('tipo_documento_codigo').setValue(null);
    this.documentoPersonaFormGroup.get('numero').setValue(null);
  }

  onChangePais(evt: MatSelectChange) {
    const paisSeleccionado = evt.value;
    const paisesDocumentoSeleccionado =
      this.documentoPersonaSet.paisesDocumento.filter(
        (pd) => pd.pais_codigo === paisSeleccionado
      );

    this.tiposDocumentosFiltrado =
      this.documentoPersonaSet.tiposDocumento.filter(
        (td) =>
          paisesDocumentoSeleccionado.findIndex(
            (pd) => pd.tipo_documento_codigo == td.codigo
          ) !== -1
      );
  }
}
